const EMPTY_BOUNDARY_VALIDATION_STATE = {
  status: "idle",
  reason: null,
  conflicts: [],
  message: "",
  showReferenceHint: true,
};

function createBoundaryValidationState(overrides = {}) {
  return {
    ...EMPTY_BOUNDARY_VALIDATION_STATE,
    ...overrides,
  };
}

function normalizeBoundaryValidationResult(result) {
  if (result?.valid) {
    return createBoundaryValidationState({
      status: "valid",
    });
  }

  if (result?.reason === "overlap") {
    return createBoundaryValidationState({
      status: "invalid",
      reason: "overlap",
      conflicts: result?.conflicts || [],
      message:
        "These boundaries overlap another saved field. Adjust the polygon before saving.",
    });
  }

  if (result?.reason === "invalid_polygon") {
    return createBoundaryValidationState({
      status: "invalid",
      reason: "invalid_polygon",
      message:
        "This polygon is not valid yet. It may need at least three points or a cleaner shape.",
    });
  }

  return createBoundaryValidationState();
}

function normalizeBoundaryValidationError(error) {
  const statusCode = error?.response?.status;
  const responseBody = error?.response?.data || {};
  const errorBody = typeof responseBody.detail === "object" && responseBody.detail !== null
    ? responseBody.detail : responseBody;

  if (
    statusCode === 409 &&
    errorBody?.error === "FIELD_BOUNDARY_OVERLAP"
  ) {
    return createBoundaryValidationState({
      status: "invalid",
      reason: "overlap",
      conflicts: errorBody?.conflicts || [],
      message:
        errorBody?.message ||
        "These boundaries overlap another saved field. Adjust the polygon before saving.",
    });
  }

  if (statusCode === 422) {
    return createBoundaryValidationState({
      status: "invalid",
      reason: "invalid_polygon",
      message:
        errorBody?.message ||
        "This polygon is not valid yet. Please redraw or adjust it.",
    });
  }

  return createBoundaryValidationState({
    status: "error",
    message:
      "Boundary pre-check is temporarily unavailable. Save will still run server-side validation.",
  });
}

function buildFieldBoundaryValidationRequest(farmId, field = {}) {
  const payload = {
    farm_id: Number(farmId),
    boundaries: field.boundaries || [],
  };

  if (field.id) {
    payload.field_id = Number(field.id);
  }

  return payload;
}

export {
  EMPTY_BOUNDARY_VALIDATION_STATE,
  buildFieldBoundaryValidationRequest,
  createBoundaryValidationState,
  normalizeBoundaryValidationError,
  normalizeBoundaryValidationResult,
};
